<script setup lang="ts">
import {useGlobalStore} from '@/stores/global'

const globalStore = useGlobalStore()
</script>

<template>
  <template v-if="globalStore.hasAuthority('ADMIN')">
    <span class="text-[10px] text-new-neutral-500">
      <i class="fa-solid fa-user-shield pr-0.5"></i>
      {{ $t('assistant.creditUsage.adminOnlyInfo') }}
    </span>
  </template>
</template>
